const localizedLinks = {
  en: {
    contact: "https://www.enerscale.co/contact",
    privacyPolicy: "https://www.enerscale.co/privacy",
    termsOfService: "https://www.enerscale.co/termsofservice",
  },
  ja: {
    contact: "https://jp.enerscale.co/contact",
    privacyPolicy: "https://jp.enerscale.co/privacy-ja",
    termsOfService: "https://jp.enerscale.co/termsofservice-ja",
  },
};

const getLocalizedLinks = (language) => {
  const languageCode = language?.split("-")[0]?.toLowerCase();

  return localizedLinks[languageCode] || localizedLinks.en;
};

export default getLocalizedLinks;
